import { Pipe, PipeTransform } from "@angular/core";
import moment from "moment";
import { BillingService } from "../services/billing.service";
import { IAggregatedChargeItemsInfo, BILLING_TYPE } from "@comunicare/comunicare-interfaces";

@Pipe({
  name: "billingLastStatus",
})
export class BillingLastStatusPipe implements PipeTransform {
  constructor(public billingService: BillingService) {}

  transform(value: IAggregatedChargeItemsInfo): string {
    let date = "";
    let status: BILLING_TYPE;
    value.chargeItems?.forEach((chargeItem) => {
      if (!date || moment(date).isBefore(moment(chargeItem.end))) {
        date = chargeItem.end;
        status = chargeItem.status;
      }
    });
    return status;
  }
}
